import { render, staticRenderFns } from "./class-abnormal-students.html?vue&type=template&id=0ac631a9&"
import script from "./class-abnormal-students.ts?vue&type=script&lang=ts&"
export * from "./class-abnormal-students.ts?vue&type=script&lang=ts&"
import style0 from "./class-abnormal-students.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports